import React from 'react';
import DatePicker from "react-datepicker";
import DatePickerWrapper from './DatePickerWrapper';
import ComponentLink from './ComponentLink';
import EffectiveDate from './EffectiveDate';
import Loader from 'react-loader';
import * as utils from '../util';
import "react-datepicker/dist/react-datepicker.css";

export default class IndexSection extends React.Component {

    render() {
        var instrumentType = this.props.instrumentType ? this.props.instrumentType : null;
        var date = this.props.endDateIndex ? this.props.endDateIndex : null;
        const style = { width: '100px', height: '25px', fontSize: '13px' };

        var rows = utils.indexPeriods.map((item, i) => {
            return (
                <tr key={i}>
                    <td className="tableCell">
                        <div className="content">{utils.getIndexName(item,instrumentType)}</div>
                    </td>
                    <td className="tableCell textMinWid">
                        <div className="content">
                            <EffectiveDate
                                isEffective={this.props.index && this.props.index[item] && !(this.props.loadingIndex) ? utils.compareDate(this.props.endDateIndex, this.props.index[item].effective_date) : true}
                                effDate={this.props.index && this.props.index[item] ? utils.formatDate(new Date(this.props.index[item].effective_date)) : ''}
                                value={utils.formatDate(new Date(date))}
                            />
                        </div>
                    </td>
                    <td className="tableCell">
                        {this.props.loadingIndex ? <Loader className="loader" color='#6f2c91' scale={0.49} loaded={false} /> :
                            this.props.isLoadIndexError || this.props.index[item] === null ? <div className='content'>Error </div> : <ComponentLink value={this.props.index[item].rate} url={utils.createIndexRateUrl(instrumentType, date, item)} pad={9} apiResponse={JSON.stringify(this.props.index[item])}/>}
                    </td>
                </tr>
            )
        });
        return (
            <div className='table-responsive'>
                <table key={'index_tbl'} className="table table-striped">
                    <thead>
                        <tr key={'index_tbl_head'} >
                            <th className="col-lg-4 col-md-5 col-sm-5 col-xs-5 tableCell"></th>
                            <th className="col-lg-3 col-md-3 col-sm-4 col-xs-4 tableCell table-head-Indices">
                                <div className="comboComp">
                                    <DatePicker
                                        id="datepicker"
                                        selected={date}
                                        dateFormat="dd/MM/yyyy"
                                        onChange={this.props.handleIndexDateChange}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        maxDate={this.props.maxDate5}
                                        yearDropdownItemNumber={15}
                                        customInput={<DatePickerWrapper />}
                                    />
                                </div>
                            </th>
                            <th className="col-lg-3 col-md-4 col-sm-5 col-xs-5 tableCell indexCol alignComboR10">Index</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows}
                    </tbody>
                </table>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/IndexSection.js